export const T = {
  en_GB: { list: "List", grid: "Grid" },
  nb_NO: { list: "Liste", grid: "Rutenett" },
} as const;
